module.exports = __webpack_public_path__ + "img/defaultskin.1b284aa0.png";